import React from "react";

export const ItemRow: React.FC<{
    icon: React.ReactNode;
    title: string;
    subtitle?: string;
    amount?: string | React.ReactNode;
    onClick?: () => void;
    endElement?: React.ReactNode;
    iconBg?: string;
}> = ({icon, title, subtitle, amount, onClick, endElement, iconBg}) => (
    <div
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
        onClick={onClick}
        className={`flex items-start gap-4 py-4 ${onClick ? 'cursor-pointer select-none' : ''}`}
    >
        <div className="flex-shrink-0">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${iconBg ?? 'bg-neutral-50 dark:bg-neutral-800'}`}>
                <div className="w-6 h-6">{icon}</div>
            </div>
        </div>
        <div className="flex-1">
            <div className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">{title}</div>
            {subtitle ? <div className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">{subtitle}</div> : null}
        </div>
        <div className="flex-shrink-0 text-sm font-medium text-neutral-900 dark:text-neutral-100 flex items-center gap-2">
            {typeof amount === 'string' ? <>{amount}</> : amount}
            <div className="w-5 min-w-5 flex-shrink-0">{endElement}</div>
        </div>
    </div>
);

export const TotalRow: React.FC<{ label: string; amount: React.ReactNode }> = ({label, amount}) => (
    <div className="flex items-center justify-between px-4 py-4 bg-neutral-50/80 dark:bg-neutral-800/40">
        <span className="text-base font-bold text-neutral-900 dark:text-neutral-100">{label}</span>
        <div className="flex items-center gap-2 flex-shrink-0">
            <span className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">{amount}</span>
            <div className="w-5 min-w-5 flex-shrink-0" />
        </div>
    </div>
);
